export const getHeader = (langCode: string) => ({
  headers: {
    'accept-language': langCode,
    'x-apicache-bypass': true,
  },
});
